<div ngClass="p-t-l p-r-l">
	<button mat-icon-button class="close-button" (click)="onCloseClick()">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
		/>
	</button>
</div>
<div ngClass="m-l-xl" fxLayout="row" fxLayoutAlign="baseline">
	<h2 i18n="@@translateAbout_translateFundraiser_title">
		Translate fundraiser About
	</h2>
	<div ngClass="p-l-m">
		<mat-spinner *ngIf="loadingText" diameter="16" color="accent"></mat-spinner>
	</div>
</div>
<mat-dialog-content class="mat-typography">
	<div fxLayout="row" fxLayout.xs="column">
		<div fxFlex="50%" fxFlex.xs="100%">
			<div ngClass="m-l-xs">
				<mat-label
					class="mat-subtitle-2"
					i18n="@@translate_about_originalLanguage_title"
					>Original Language</mat-label
				>
				<div fxLayout="row" ngClass="p-xs" fxLayoutAlign="start center">
					<img
						width="20px"
						src="{{ languageIconPath + originalLocale + '1/public' }}"
					/>&nbsp;
					<span>{{ allLanguages[originalLocale] }}</span>
				</div>
			</div>
			<br />
			<!-- <div class="m-l-xs m-r-xs">
				<mat-label i18n="@@translate_about_fundraiser_title"
					>Fundraiser Title</mat-label
				>
				<fieldset class="disable" disabled>
					<form>
						<mat-form-field class="w-100" appearance="outline">
							<input
								[value]="this.originalTitle"
								matInput
								placeholder="Placeholder"
							/>
						</mat-form-field>
					</form>
				</fieldset>
			</div> -->
			<!-- <mat-label class="m-l-xs" i18n="@@translateAbout_aboutFundraiser_label"
				>About Fundraiser</mat-label
			> -->
			<app-quill-editor
				[quillContent]="originalQuillContent"
				[readOnly]="true"
			></app-quill-editor>
		</div>
		<div fxFlex="50%" fxFlex.xs="100%">
			<div ngClass="m-l-xs">
				<mat-label
					class="mat-subtitle-2"
					i18n="@@translateAbout_translationLanguage_label"
					>Translation Language</mat-label
				>
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<ng-container [ngTemplateOutlet]="langSwitcher"></ng-container>
					<div>
						<button
							mat-stroked-button
							color="accent"
							id="autoTranslateButton"
							[disabled]="isAutoTranslating"
							(click)="autoTranslate()"
						>
							<span i18n="@@translate_about_autoTranslation_label"
								>Auto Translate</span
							>
							<mat-icon *ngIf="isAutoTranslating" ngClass="m-l-xs">
								<mat-spinner color="primary" diameter="16"> </mat-spinner>
							</mat-icon>
						</button>
					</div>
				</div>
			</div>
			<br />
			<!-- <div class="m-l-xs m-r-xs">
				<mat-label i18n="@@translate_about_fundraiser_title"
					>Fundraiser Title</mat-label
				>
				<form [formGroup]="titleFormGroup">
					<mat-form-field class="w-100" appearance="outline">
						<input
							matInput
							placeholder="Placeholder"
							formControlName="translationTitle"
						/>
					</mat-form-field>
				</form>
			</div> -->
			<!-- <mat-label class="m-l-xs" i18n="@@translateAbout_aboutFundraiser_label"
				>About Fundraiser</mat-label
			> -->
			<app-quill-editor
				[quillContent]="quillContent"
				[control]="quillContentCtrl"
				(onContentChange)="changeAboutContent($event)"
				(allTextCheck)="allCheck($event)"
				(pasteDetected)="handlePasteDetected($event)"
			></app-quill-editor>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		mat-button
		color="accent"
		[disabled]="isLoading || isDisable"
		(click)="discardAllAboutChanges()"
		i18n="@@button_discardAll"
	>
		Discard All
	</button>
	<button
		mat-flat-button
		color="accent"
		id="translate_button_save_all"
		[disabled]="
			isLoading || isDisable || !this.allTextCheck || this.isDescriptionEmpty
		"
		(click)="saveTranslations()"
	>
		<span i18n="@@button_saveAll">Save All</span>
		<mat-icon *ngIf="isLoading" ngClass="m-l-xs">
			<mat-spinner color="accent" diameter="16" i18n="@@translateAbout_spinner">
			</mat-spinner>
		</mat-icon>
	</button>
</mat-dialog-actions>

<ng-template #langSwitcher>
	<div>
		<button
			id="langSwitcher"
			mat-button
			[matMenuTriggerFor]="menu"
			ngClass="m-l-xs"
		>
		    <div fxLayoutAlign="start center">
				<img
					width="20px"
					src="{{ languageIconPath + selectedLocale + '1/public' }}"
				/>&nbsp;
				<span>{{ allLanguages[selectedLocale] }}</span>
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/keyboard_arrow_down/public"
				/>
			</div>
		</button>
	</div>
	<mat-menu #menu="matMenu" class="translationMenuContainerDropDown">
		<ng-container *ngFor="let locale of translationLocaleArr">
			<button mat-menu-item (click)="changeLanguage(locale)">
				<img
					width="20px"
					src="{{ languageIconPath + locale + '1/public' }}"
				/>&nbsp;
				<span id="{{ 'languageChooser_' + locale + '_button' }}"
					>{{ locale | uppercase }} -
					{{ allLanguages[locale] | titlecase }}</span
				>
			</button>
		</ng-container>
	</mat-menu>
</ng-template>
